<template>
	<div>
		<div class="pa-40 textAlignCenter" v-if="selectedItem.id">
			<AssetResume :data="selectedItem" type="SP"/>
		</div>
		<div class="pa-40 textAlignCenter" v-else>
			<div v-if="error">
				{{error}}
			</div>
			<div v-else>
				Cargando...
			</div>
		</div>
	</div>
</template>

<script>
import asset_review from '@/modules/CA_SP/mixins/asset_review.js';

export default {
  mixins: [asset_review],
  data() {
    return {
			type:'my_pending_sp',
      pending_types: ['my_pending_sp'],
      asset_folder: 'sp',
      asset_type: 'spare_part',
			error:'',
		};
	},
};
</script>
